module.exports = __webpack_public_path__ + "static/media/ocf.c423a231.jpg";